var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTryBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1277,
    height: 500,
    viewBox: "0 0 1277 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_337)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1276.8,
    height: 499.16,
    rx: 32,
    fill: "#4649E5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_185_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1072.2 6.96411V128.901C1072.2 147.163 1087 161.968 1105.26 161.968H1278.86",
    stroke: "white",
    strokeWidth: 4.27141,
    strokeLinecap: "round",
    strokeDasharray: "8.27 14.47"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1071.45,
    y: -43.9316,
    width: 62.13,
    height: 62.13,
    transform: "rotate(45 1071.45 -43.9316)",
    fill: "#2BCA76",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_185_337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43006 41.0415H115.143C151.829 41.0415 181.57 70.7804 181.57 107.465C181.57 144.15 151.829 173.889 115.143 173.889H4.42987",
    stroke: "white",
    strokeWidth: 3.66106,
    strokeLinecap: "round",
    strokeDasharray: "7.09 12.4"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 18.53,
    y: 142.53,
    width: 62.13,
    height: 62.13,
    rx: 31.065,
    fill: "#FFD231",
    stroke: "black",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1276.8,
    height: 499.16,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_185_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210.8,
    height: 169.47,
    fill: "white",
    transform: "translate(1070.13)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_185_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 136.39,
    fill: "white",
    transform: "translate(0 39.27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryBg);
export default __webpack_public_path__ + "static/media/tryBg.2e49361986db19deadb333dc946b68bf.svg";
export { ForwardRef as ReactComponent };